//import ShopFunc from "@/pcomponents/common/content/shop/order/func/shop_func";
class ShopFunc{
  //상태(ready,ready_pay,request,accept,move,complete)
  static select_order_state_arr=[
    {value:"ready",text:"장바구니"},
    {value:"ready_pay",text:"결제중"},
    {value:"request",text:"결제완료"},
    {value:"accept",text:"준비중"},
    {value:"move",text:"배송중"},
    {value:"complete",text:"완료"},
  ];
  static select_in_out_arr=[
    {value:"in",text:"입고"},
    {value:"out",text:"판매"},
  ];
  static select_pay_sort=[
    {value:"payt",text:"결제선생"},
    {value:"point",text:"포인트"},
  ];
  static select_order_product_type=[
    {value:"mtextbook",text:"교재"},
    {value:"mtextbook_period",text:"온라인"},
  ];
}
export default ShopFunc;